define('SuiteDynamics.PLPCanonicalURL.Entrypoint',
	[
		'SuiteDynamics.PLPCanonicalURL.FacetsExtensions'
	],
	function (
		FacetsExtensions
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {
			FacetsExtensions.mountToApp(container);
		}
	};
});
